import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import Hero from '../components/Hero';

export default function render() {
  return (
    <Layout>
      <SEO title="Cadastre-se para receber novidades da Sâmia" />
      <Hero />
    </Layout>
  );
}
